import {
  FiActivity,
  FiBarChart2,
  FiBriefcase,
  FiCheckSquare,
  FiFlag,
  FiHeart,
  FiHome,
  FiPieChart,
  FiSettings,
  FiTarget,
  FiTrendingUp,
  FiUsers,
} from "react-icons/fi";

export const CRM_NAV_DEFINITIONS = [
  { key: "dashboard", path: "/crm/dashboard", Icon: FiHome },
  { key: "contacts", path: "/crm/contacts", Icon: FiUsers },
  { key: "companies", path: "/crm/companies", Icon: FiBriefcase },
  { key: "leads", path: "/crm/leads", Icon: FiFlag },
  { key: "opportunities", path: "/crm/opportunities", Icon: FiTarget },
  { key: "activity", path: "/crm/activity", Icon: FiActivity },
  { key: "tasks", path: "/crm/tasks", Icon: FiCheckSquare },
  { key: "campaigns", path: "/crm/campaigns", Icon: FiTrendingUp },
  { key: "loyalty", path: "/crm/loyalty", Icon: FiHeart },
  { key: "reports", path: "/crm/reports", Icon: FiBarChart2 },
  {
    key: "settings",
    activePrefix: "/crm/settings",
    Icon: FiSettings,
    children: [
      { key: "userExperience", path: "/crm/settings/user-experience" },
      { key: "opportunityPipelines", path: "/crm/settings/pipelines" },
    ],
  },
];

export const CRM_METRIC_KEYS = [
  "contacts",
  "companies",
  "leads",
  "opportunities",
  "open_tasks",
  "activities_this_week",
];

export const CRM_PIPELINE_ICON = FiPieChart;

export function buildCrmNavigation(copy) {
  return CRM_NAV_DEFINITIONS.map((item) => ({
    ...item,
    label: copy.nav[item.key]?.label || item.key,
    meta: copy.nav[item.key]?.meta || "",
    children: item.children?.map((child) => ({
      ...child,
      label: copy.nav[child.key]?.label || child.key,
    })),
  }));
}

export function buildCrmMetricItems(copy) {
  return CRM_METRIC_KEYS.map((key) => ({
    key,
    label: copy.metrics[key] || key,
  }));
}
